// Google Tagmanager Enhanced Ecommerce
import { gtmEcommerceEvents } from './../helpers/gtmEcommerceEvents';
window.gtmEcommerceEvents = gtmEcommerceEvents();

(() => {
	if(window.dataLayer) {

		// Add Event listeners to product in content paragraphs
		const allProductsInContent = document.querySelectorAll('.content-product-list__clickable, .single-product__link, .products-module__link');

		[...allProductsInContent].forEach(product => {
			product.addEventListener('click', function(event) {

				try {	
					event.preventDefault();
					const target = event.currentTarget;

					const product = {
						id: target.dataset.id,
						name: target.dataset.name,
						number: target.dataset.number,
						discount: target.dataset.gtmdiscount,
						position: target.dataset.position,
						brand: target.dataset.brand,
						category: target.dataset.category,
						listid: target.dataset.listid,
						listname: target.dataset.listname,
						variantid: target.dataset.variantid,
						price: target.dataset.gtmprice,
						url: target.href,
					};

					pushProductToDataLayer(product, event.ctrlKey);
				} catch(err) {
					document.location = event.currentTarget.href;
				}

			});
		});

		const pushProductToDataLayer = (p, isCtrlPress) => {
			dataLayer.push({
				'event': 'select_item',
				'ecommerce': {
					'items': [{
						'item_id': p.id,
						'item_name': p.name,
						'item_number': p.number,
						'discount': Number(p.discount),
						'index': Number(p.position),
						'item_brand': p.brand,
						'item_category': p.category,
						'item_list_id': p.listid,
						'item_list_name': p.listname,
						'item_variant': p.variantid,
						'price': Number(p.price),
						'quantity': 1
					}]
				},
				'eventCallback': function() {
					if (isCtrlPress) {
						window.open(p.url);
						window.focus();
					} else {
						document.location = p.url;
					}
				},
				'eventTimeout' : 2000
			});
		};

	}
})();
